import SignupAcceptInviteForm from '../../components/screens/signup/SignupAcceptInviteForm';
import NavBrandDark from '../../components/common/NavbarBrandDark';
import BackgroundImage from '../../assets/img/banner-img.jpg';
import { Box, Grid2 } from '@mui/material';
import SignupForm from '../../components/screens/signup/SignupForm';

const Signup = () => {
  const inviteId = window.location.hash.split('=')[1];

  return (
    <Box height="100vh">
      <Grid2 container spacing={3} sx={{ height: '100%' }}>
        <Grid2
          size={{ lg: 6, md: 6, sm: 0, xs: 0 }}
          sx={{
            backgroundImage: `url(${BackgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="banner-bg">
            <header>
              <NavBrandDark />
            </header>
          </div>
        </Grid2>
        <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
          {!inviteId ? <SignupForm /> : <SignupAcceptInviteForm className="signup__form" />}
        </Grid2>
      </Grid2>
    </Box>
  );
};
export default Signup;
